import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'next-i18next'; // https://www.i18next.com/
import Form from 'components/Form';
import Fieldset from 'components/Fieldset';
import FormRow from 'components/FormRow';
import CityInput from 'components/CityInput';

function CreateApplicantForm({
  handleNameChange,
  onInputChange,
  loading,
  inputs,
  saving,
  saveError,
  setLatLong,
}) {
  const { t } = useTranslation();

  return (
    <Form saveError={saveError} loading={loading}>
      <Fieldset title={t('personalInformation')} disabled={saving}>
        <div className="o-layout o-layout--gutter-base">
          <div className="o-layout__cell o-layout__cell--fill@from-md">
            <FormRow
              label={t('name.label')}
              placeholder={t('name.placeholder')}
              inputType="text"
              name="name"
              id="name"
              value={inputs.name}
              onChange={handleNameChange}
              required
            />
          </div>
          <div className="o-layout__cell o-layout__cell--fill@from-md">
            <FormRow
              label={t('email.label')}
              placeholder={t('email.placeholder')}
              inputType="email"
              name="email"
              id="email"
              value={inputs.email}
              onChange={onInputChange}
              required
            />
          </div>
        </div>
        <div className="o-layout o-layout--gutter-base u-negative-margin-bottom-base">
          <div className="o-layout__cell o-layout__cell--fill@from-md">
            <FormRow
              label={t('phoneNumber.label')}
              placeholder={t('phoneNumber.placeholder')}
              inputType="text"
              name="phoneNumber"
              id="phoneNumber"
              value={inputs.phoneNumber}
              onChange={onInputChange}
              required
            />
          </div>
          <div className="o-layout__cell o-layout__cell--fill@from-md">
            <CityInput
              value={inputs.city}
              onChange={onInputChange}
              setLatLong={setLatLong}
            />
          </div>
        </div>
      </Fieldset>
    </Form>
  );
}

CreateApplicantForm.propTypes = {
  handleNameChange: PropTypes.func,
  onInputChange: PropTypes.func,
  setLatLong: PropTypes.func,
  inputs: PropTypes.object,
  saving: PropTypes.bool,
  saveError: PropTypes.object,
  loading: PropTypes.bool,
};

export default CreateApplicantForm;
